<template>
  <div>
    <span class="razonSocial" v-tooltip="tipoRazonSocial">{{ razonSocial }}</span>
    <div>
      <vs-chip :color="colores.navbar">
        {{ traducitTipoDocumentoEnPalabras(documento.tipoDocumento) }}
      </vs-chip>
      <vs-chip color="#aaa" v-tooltip="'Folio'">
        # {{ documento.folio }}
      </vs-chip>
      <vs-chip color="primary" v-if="documento.diasParaPago>0"
               v-tooltip="'Días faltantes para pago, tomando en cuenta 30 días'">
        {{ documento.diasParaPago}}
      </vs-chip>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import TiposDteMixin from '../../mixins/TiposDteMixin';

export default {
  name: 'CampoDocumento',
  mixins: [TiposDteMixin],
  props: {
    documento: {
      type: Object,
    },
  },
  computed: {
    ...mapState('Empresas', {
      empresaActual: (state) => state.empresa,
    }),
    ...mapState('Personalizacion', {
      colores: (state) => state.colores,
    }),
    tipoRazonSocial() {
      if (this.empresaActual.iut === this.documento.rutEmisor) {
        return 'Razón Social Receptor';
      }
      return 'Razón Social Emisor';
    },
    razonSocial() {
      if (this.empresaActual.iut === this.documento.rutEmisor) {
        return this.documento.razonSocialReceptor;
      }
      return this.documento.razonSocialEmisor;
    }
  }
};
</script>

<style scoped>
  .razonSocial{
    font-size:90%;
    font-weight: bold;
  }
</style>
